/**
 * Спінер або назва на кнопці.
 * Спінер у фіксованому слоті — Safari не роздуває ширину кнопки через transform.
 */
const { Spinner } = require('react-bootstrap');

const spinnerTitle = (titleButton, showSpinner, titleSpinner) => {
    if (!showSpinner) return titleButton;

    return (
        <>
            <span className="btn-spinner-slot" aria-hidden="true">
                <Spinner as="span" animation="border" size="sm" role="status" />
            </span>
            <span className="text-nowrap">{titleSpinner}</span>
        </>
    );
};

export default spinnerTitle;
